module.exports = __webpack_public_path__ + "img/icon3.6908cbc8.png";